import { LOCKED_SERVER_URL } from '@/services/xtream-api';

export interface Provider {
  id: string;
  /** User-facing name. The underlying URL is never shown in the UI. */
  label: string;
  url: string;
}

/**
 * Selectable providers shown in the login "Server" dropdown. Only the labels are
 * displayed; the URLs stay internal so different providers/clients can use the
 * same app without exposing their lines. Add/remove entries here to manage them.
 */
export const PROVIDERS: Provider[] = [
  { id: 'A', label: 'RedHood A', url: LOCKED_SERVER_URL },
  { id: 'B', label: 'RedHood B', url: 'https://3872298893.trustissues.life' },
  { id: 'C', label: 'RedHood C', url: 'https://ottipdns.com' },
];

/** Apply admin overrides (by id) on top of the built-in provider defaults. */
export function resolveProviders(overrides: Record<string, string> = {}): Provider[] {
  return PROVIDERS.map((p) => ({ ...p, url: (overrides[p.id] || '').trim() || p.url }));
}
